import {Contact, Favorite, FavoriteList, Lots} from '@models/favorite';
import {Ad} from '@models/ad';
import {City} from '@models/city';
import {User} from '@models/user';
import {CityParams, SearchParams} from '@models/search';

export const EMPTY_RENT = {
    lM: 0,
    lC_ols: 0,
    L: 0,
    U: 0,
    x0: 0,
    x1: 0,
    x0_l: 0,
    x1_l: 0,
    x0_u: 0,
    x1_u: 0,
    s_min: 0,
    s_moy: 0,
    s_max: 0,
    cL: 0,
};

export const EMPTY_PRICE = {
    pM: 0,
    pC: 0,
    q25: 0,
    q75: 0,
    cL: 0,
};

export const EMPTY_SQUARE_LIMIT = {
    square_q250: 0,
    square_q975: 0,
};

export const EMPTY_LOGEMENT = {
    PL_LOG: 0,
    T_RP: 0.0,
    T_RS: 0.0,
    T_LV: 0.0,
    T_Mai: 0.0,
    T_Appt: 0.0,
    T_F1: 0.0,
    T_F2: 0.0,
    T_F3: 0.0,
    T_F4: 0.0,
    T_F5: 0.0,
    T_Men_park: 0.0,
    'T_Men_1+voit': 0.0,
    anc_loc_ann: 5.0,
    TF: 0,
    T_PROP: 0,
    T_LOC: 0,
};
export const EMPTY_SERVICE = {
    tot_service: 0,
    police: 0,
    gendarm: 0,
    banque: 0,
    bureau_poste: 0,
    relais_poste: 0,
    agence_poste: 0,
    auto_ecole: 0,
    coiffeur: 0,
    veto: 0,
    agence_interim: 0,
    restaurant: 0,
    agence_immo: 0,
    pressing_laverie: 0,
    institut_beaute: 0,
    med_generaliste: 0
};

export const EMPTY_CARAC_COMMUNE = {
    P0014: 0,
    P1529: 0,
    P3044: 0,
    P4559: 0,
    P6074: 0,
    P75P: 0,
    MED_NV: 0,
    T_actif: 0,
    T_actif_occ: 0,
    T_chom: 0,
    T_inactif: 0,
    T_etud: 0,
    T_retraite: 0,
    T_autre_inac: 0,
};

export const EMPTY_COMMERCE = {
    tot_com: 0,
    hypmar: 0,
    supmar: 0,
    brico: 0,
    supe: 0,
    epice: 0,
    boulan: 0,
    bouch: 0,
    surge: 0,
    poisson: 0,
    lib: 0,
    vet: 0,
    equ: 0,
    chaus: 0,
    electro: 0,
    meub: 0,
    sport: 0,
    revet: 0,
    droguerie: 0,
    parfum: 0,
    horlog: 0,
    fleur: 0,
    opt: 0,
    medi: 0,
    essence: 0,
    pharma: 0
};

export const EMPTY_ECOLE = {
    tot_ecole: 0,
    cpge: 0,
    form_sante: 0,
    form_commerce: 0,
    autre_postbac: 0,
    unite_de_form_et_recherche: 0,
    institut_universitaire: 0,
    ecole_inge: 0,
    enseign_general_sup_prive: 0,
    enseign_sup_agricole: 0,
    autre_enseign_sup: 0,
    centre_form_apprentis: 0,
    greta: 0,
    centre_form_agricole: 0,
    form_sport: 0,
    form_apprentissage_agricole: 0,
    autre_form_continu: 0,
    college: 0,
    lycee_gen_techno: 0,
    lycee_pro: 0,
    lycee_techniqe_etou_pro_agricole: 0,
    maternelle: 0,
    elementaire: 0
};

export const EMPTY_MENAGE = {
    C_MEN: 0,
    T_seul: 0.0,
    T_F_0enf: 0.0,
    T_F_1enf: 0.0,
    T_F_2enf: 0.0,
    T_F_3enf: 0.0,
    T_F_4enf: 0.0
};

export const EMPTY_TOURISME = {
    tot_tourisme: 0,
    taxi: 0,
    aero: 0,
    gare_nat: 0,
    gare_reg: 0,
    gare_loc: 0,
    agence_voy: 0,
    hotel: 0,
    camping: 0,
    info_tour: 0
};

export const EVOL_DEMO_LAST_YEAR = 2023
export const PRICE_EVOL_LEGENT = [
    '2014 S1', '2014 S2',
    '2015 S1', '2015 S2',
    '2016 S1', '2016 S2',
    '2017 S1', '2017 S2',
    '2018 S1', '2018 S2',
    '2019 S1', '2019 S2',
    '2020 S1', '2020 S2',
    '2021 S1', '2021 S2',
    '2022 S1', '2022 S2',
    '2023 S1', '2023 S2',
    '2024 S1', '2024 S2',
    '2025 S1', '2025 S2',
];

export const EMPTY_LOT: Lots = {
    title: '',
    estate_type: '',
    square: 0,
    rooms: 0,
    amount_rent: 0,
    furnish: 0,
    amount_copro_rent: 0,
    advice_rent_choice: '',
    advice_rent: 0,
    advice_rent_amount: 0,
    advice_rent_L: 0,
    advice_rent_U: 0,
    advice_rent_cL: 0,

    works_help: 0,
    works_square_price: 0,
    works_total: 0,

    night_price: 0,
    night_number: 0,

    nb_lots: 1,

    window: '',
    heating: '',
    dpe: '',
    dpe_after: '',
    comment: '',
};

export const EMPTY_CONTACT: Contact = {
    name: '',
    phone: '',
    email: '',
};

export const EMPTY_CITY: City = {
    name: '',
    slug: '',
    zip_code: '',
    city_code: '',
    display_zip_code: '',
    departement: '',
    region: '',
    image: '',
    km: 0,
    type: '',

    edilos_active: false,
    edilos_min: 0,

    carac_commune: EMPTY_CARAC_COMMUNE,
    carac_commune_fr: EMPTY_CARAC_COMMUNE,
    carac_commune_gq: {},
    carac_commune_iris: {},
    demographie_annuelle: {
        1999: 0,
        2000: 0,
        2001: 0,
        2002: 0,
        2003: 0,
        2004: 0,
        2005: 0,
        2006: 0,
        2007: 0,
        2008: 0,
        2009: 0,
        2010: 0,
        2011: 0,
        2012: 0,
        2013: 0,
        2014: 0,
        2015: 0,
        2016: 0,
        2017: 0,
        2018: 0,
        Cr: 0,
    },
    taxe_fonciere_annuelle: {},
    loc_service_tensiometre: {
        all: {
            loc: '0',
            budget: '0',
        },
        chambre: {
            loc: '0',
            budget: '0',
        },
        studio: {
            loc: '0',
            budget: '0',
        },
        T2: {
            loc: '0',
            budget: '0',
        },
        T3: {
            loc: '0',
            budget: '0',
        },
        T5: {
            loc: '0',
            budget: '0',
        },
        F3: {
            loc: '0',
            budget: '0',
        }
    },
    loyer_moyen_ville: {
        A: EMPTY_RENT,
        M: EMPTY_RENT,
        C: EMPTY_RENT,
        P: EMPTY_RENT,
    },
    loyer_moyen_ville_meuble: {
        A: EMPTY_RENT,
        M: EMPTY_RENT,
        P: EMPTY_RENT,
    },
    loyer_moyen_ville_non_meuble: {
        A: EMPTY_RENT,
        M: EMPTY_RENT,
        P: EMPTY_RENT,
    },
    loyer_moyen_petite_ville: EMPTY_RENT,
    loyer_moyen_petite_ville_cp: EMPTY_RENT,
    loyer_moyen_ville_nb_piece: {},
    loyer_moyen_ville_nb_piece_meuble: {},
    loyer_moyen_ville_nb_piece_non_meuble: {},
    loyer_moyen_ville_coloc: EMPTY_RENT,
    prix_commune: {
        A: EMPTY_PRICE,
        M: EMPTY_PRICE,
        T: EMPTY_PRICE,
        P: EMPTY_PRICE,
        B: EMPTY_PRICE
    },
    prix_commune_gq: {
        A: EMPTY_PRICE,
        M: EMPTY_PRICE,
        T: EMPTY_PRICE,
        P: EMPTY_PRICE,
        B: EMPTY_PRICE
    },
    prix_commune_iris: {
        A: EMPTY_PRICE,
        M: EMPTY_PRICE,
        T: EMPTY_PRICE,
        P: EMPTY_PRICE,
        B: EMPTY_PRICE
    },
    prix_commune_nb_piece: {
        A: {},
        M: {}
    },
    prix_commune_nb_piece_gq: {
        A: {},
        M: {}
    },
    prix_commune_nb_piece_iris: {
        A: {},
        M: {}
    },
    prix_departement: {
        A: [
            EMPTY_PRICE,
        ],
        M: [
            EMPTY_PRICE,
        ]
    },
    prix_ville: {
        A: [
            EMPTY_PRICE,
        ],
        M: [
            EMPTY_PRICE,
        ]
    },
    service: EMPTY_SERVICE,
    service_fr: EMPTY_SERVICE,
    service_gq: {},
    service_iris: {},
    commerce: EMPTY_COMMERCE,
    commerce_fr: EMPTY_COMMERCE,
    commerce_gq: {},
    commerce_iris: {},
    ecole: EMPTY_ECOLE,
    ecole_fr: EMPTY_ECOLE,
    ecole_gq: {},
    ecole_iris: {},
    logement: EMPTY_LOGEMENT,
    logement_fr: EMPTY_LOGEMENT,
    logement_iris: {},
    logement_gq: {},
    menage: EMPTY_MENAGE,
    menage_fr: EMPTY_MENAGE,
    menage_iris: {},
    menage_gq: {},
    tourisme: EMPTY_TOURISME,
    tourisme_fr: EMPTY_TOURISME,
    tourisme_iris: {},
    tourisme_gq: {},
    ets: {
        ETNTOT14: 0,
        ETNTOT15: 0,
        ETNTOT16: 0,
        ETNTOT17: 0,
        ETNTOT18: 0,
        ETNTOT19: 0,
        ETNTOT20: 0,
        ETNTOT21: 0,
        ETNTOT22: 0,
        ETNTOT23: 0,
    },
    renta: {
        r: 0,
        r_type: "B",
    },
    evol_prix_ville: {
        evol_1y: '',
        evol_3y: '',
        evol_5y: '',
        evol_10y: '',
    },
    mapping_quartier_iris: {
        quartier: [
            {
                GQ_n: '',
                GQ_c: '',
                iris: [
                    {
                        IRIS_n: '',
                        IRIS_c: '',
                    }
                ]
            }
        ]
    },
    square_limit_nb_piece: {
        A: {
            1: EMPTY_SQUARE_LIMIT,
            2: EMPTY_SQUARE_LIMIT,
            3: EMPTY_SQUARE_LIMIT,
            4: EMPTY_SQUARE_LIMIT,
            5: EMPTY_SQUARE_LIMIT,
        },
        M: {
            1: EMPTY_SQUARE_LIMIT,
            2: EMPTY_SQUARE_LIMIT,
            3: EMPTY_SQUARE_LIMIT,
            4: EMPTY_SQUARE_LIMIT,
            5: EMPTY_SQUARE_LIMIT,
        },
    },
    square_limit: {
        I: EMPTY_SQUARE_LIMIT,
        P: EMPTY_SQUARE_LIMIT,
    },
    iris_shapes: [],
};

export const EMPTY_FAVORITE_LIST: FavoriteList = {
    id: '',
    title: '-',
    user_id: 0,
    favorites: [],
    share: false,
    owner_name: '',
};

export const EMPTY_USER: User = {
    created_at: '',
    id: -1,
    email: '',
    firstname: '',
    lastname: '',
    adress: '',
    code_filleul: '',
    code_parrainage: '',
    city: '',
    zip_code: '',
    company_name: '',
    mailing: false,
    agence: 0,
    notary_old: 8.5,
    notary_new: 2.5,
    default_work: 0,
    default_work_value: 0,
    other_fees: 0,
    other_fees_min: 0,
    other_fees_work: 0,
    other_fees_work_min: 0,
    agence_rental: 0,
    rental_vacancy: 0,
    other_bill: 0,
    amount_rent_insurance: 0,
    apport: 0,
    duration: 20,
    rate: 1.2,
    rate_insurance: 0.2,
    banking_fees: 0,
    apport_notary: 0,
    work_1: 250,
    work_2: 500,
    work_3: 800,
    building_insurance: 0,
    accouting_fees: 0,
    deposit_fees: 0,
    cfe_contribution: 0,

    part_field: 10,

    // Meubles
    amort_duration_furniture: 6,

    // gros oeuvre
    part_structure: 50,
    amort_duration_structure: 50,

    // Facade
    part_facade: 10,
    amort_duration_facade: 50,

    // Agencement
    part_arrangment: 20,
    amort_duration_arrangment: 6,

    // Equipement
    part_equipment: 20,
    amort_duration_equipment: 30,

    amort_duration_agency_fees: 6,
    amort_duration_work: 6,

    fiscal_choice: '',
    shares_number: 1,
    annual_income: 0,
    annual_income_sci: 0,

    // Plan
    plan: '',
    exclude: false,
    pro_plan: '',
    pro_data: '',
    api_plan: '',
    api_plan_credit: 0,
    api_plan_renew_date: '',
    api_ayg_credit: 0,
    api_ayg_expire_date: '',
    ai_credit: 0,
    ai_credit_renew_date: '',
    subscription_api: {
        subscription_id: '',
        status: '',
        plan: '',
        duration: '',
        cancel_date: '',
        current_period_end: '',
    },
    valid_filleul: false,
    total: 0,

    form: false,
    rate_form: false,
    news_form: false,
    popup_endtrial: false,
    header_form: false,

    user_dashboard: {
        pdf_profil: '',
        pdf_page: [],
        pdf_kpi: [],
        pdf_quality: '',
        sidebar_collapse: false,
        favorite_kpi: [],
        search_kpi: [],
    },
    user_onboarding: {
        search: {
            status: '',
            date_start: '',
            date_end: '',
        },
        annonce: {
            status: '',
            date_start: '',
            date_end: '',
        },
        compare: {
            status: '',
            date_start: '',
            date_end: '',
        },
        alert: {
            status: '',
            date_start: '',
            date_end: '',
        },
        favoris_list: {
            status: '',
            date_start: '',
            date_end: '',
        },
        ville: {
            status: '',
            date_start: '',
            date_end: '',
        },
        search_save: {
            status: '',
            date_start: '',
            date_end: '',
        },
        pdf: {
            status: '',
            date_start: '',
            date_end: '',
        },
        parameters: {
            status: '',
            date_start: '',
            date_end: '',
        },
        finish: true,
        auto: true,
        open: true,
        dismiss: false,
        dismiss_date: '',
        show_historic: true,
        show_save_search: true,
        show_list_search: true,
        show_save_city_search: true,
        show_save_search_city_search: true,
        show_rate: true,
        show_calendly: true,
        popup_search_save: '',
        popup_search_fav: true,
        show_pro_popup: false,
    },
    answer: {
        profil: '',
    },
    rate_answer: {
        general: 0,
    },
    p: '0',
    subscription: {
        subscription_id: '',
        status: '',
        plan: '',
        duration: '',
        cancel_date: '',
        current_period_end: '',
    },
    payment_method: {
        type: '',
        type_detail: '',
        exp_month: 0,
        exp_year: 0,
        last_4: '',
    },

    double_auth_code: '',
    double_auth_code_at: '',
    double_auth_disable: false,

    trial_end_date: '',
    trial_plus_end_date: '',
    show_trial_inc: false,

    promo_end_date: '',
    show_promo: false,
    publisher: false,
    publisher_contact: '',
    publisher_company: '',
};

export const EMPTY_AD: Ad = {
    id: '',
    ai_id: 0,
    price: 0,
    city: EMPTY_CITY,
    estate_sale: '',
    estate_type: '',
    real_estate_type: '',
    square: 0,
    square_land: 0,
    rooms: 0,
    parking: 0,
    year_building: 0,
    floor: 0,
    floor_building: 0,
    bedrooms: 0,
    bathrooms: 0,
    shower_rooms: 0,
    restrooms: 0,
    elevator: false,
    cellar: false,
    pool: false,
    outside: false,
    renov: false,
    disabled_access: false,
    guardian: false,
    intercom: false,
    closed_view: false,
    digital_code: false,
    orientation: '',
    price_change: false,
    current_date: '',
    first_publication_date: '',
    fpb: '',
    expiration_date: '',
    is_active: false,
    category: '',
    title: '',
    description: '',
    urls: [],
    prices: [],
    has_local_commercial: false,
    lot_copro: 0,
    has_copro: false,

    owner_type: '',
    owner_siren: '',
    owner_name: '',
    owner_reference: '',
    owner_adress: '',
    owner_contact: '',
    owner_email: '',
    owner_phone: '',
    urgent: false,
    pictures_string: '',
    pictures: [],

    energy_rate: '',
    energy_rate_value: 0,
    ges: '',
    ges_value: 0,
    ref_ademe: '',

    work: false,
    rent: false,
    divisible: false,

    adress: '',
    iris: '',
    bad_location: false,
    latitude: 0,
    longitude: 0,
    exact_adresse: false,
    radius_location: 0,
    first_provider: '',
    user_favorite: null,
};

export const EMPTY_FAVORITE: Favorite = {
    id: '',
    public_id: '',
    mask: false,
    ad: EMPTY_AD,
    ad_id: 0,
    ad_city: EMPTY_CITY,
    comment: '',
    other_comment: '',
    comment_work: '',
    comment_city: '',
    comment_copro: '',
    comment_building: '',
    adress: '',
    iris: '',
    latitude: 0,
    longitude: 0,
    exact_adresse: false,

    created_at: '',
    title: '',
    description: '',
    pictures_string: '',
    pictures_number: '',
    pictures: [],
    price: 0,
    init_price: 0,
    estate_sale: 'Ancien',
    estate_type: '',
    square: 0,
    square_land: 0,
    rooms: 0,

    amount_property_tax: 0,
    amount_rent: 0,
    amount_copro: 0,
    amount_copro_rent: 0,

    advice_rent_choice: '',
    advice_rent: 0,
    advice_rent_amount: 0,
    advice_rent_L: 0,
    advice_rent_U: 0,
    advice_rent_real: '',
    advice_rent_cL: 0,
    advice_rent_square: 0,

    advice_price: 0,
    advice_price_choice: 'city.prix_commune.B',
    advice_price_real: 'city.prix_commune.B',
    advice_price_L: 0,
    advice_price_U: 0,
    advice_price_cL: 0,
    furnish: 0,

    // Extra fields
    notary_price: 0,
    works_help: 0,
    works_square_price: 0,
    works_total: 0,
    works_not_deduc: 0,

    total_price: 0,
    coverage_rate: 0,
    cash: false,
    apport: 0,
    duration: 20,
    rate: 1.6,
    rate_second: 1.6,
    rate_insurance: 0.2,
    charge: 0,

    efficiency_brut: 0,
    efficiency_net: 0,
    net_rent: 0,

    building_insurance: 0,
    agence: 0,
    amount_rent_insurance: 0,
    rental_vacancy: 0,
    other_bill: 0,
    monthly: 0,
    loaning: 0,
    cash_flow: 0,

    lots: [EMPTY_LOT],
    nb_lots: 1,
    contacts: [EMPTY_CONTACT],

    company: false,
    works_deduc: false,

    // Impots
    agency_fees: 0,
    other_fees: 0,
    other_fees_work: 0,
    agence_rental: 0,
    furniture_price: 0,
    works_duration: 0,
    rent_before_work: 0,
    annual_rent_increase: 2,
    annual_bill_increase: 2,
    accouting_fees: 0,
    cfe_contribution: 0,
    cga_contribution: 0,
    is_cga_in_charges: true,
    banking_fees: 0,
    deposit_fees: 0,
    tmi: 0,
    annual_income: 0,
    annual_income_sci: 0,
    fiscal_choice: '',
    fiscal_choice_cat: '',
    location_engagement_duration: 0,
    available_work_price: 0,
    selling: false,
    selling_year: 10,
    selling_price: 0,
    selling_price_calc: false,
    selling_price_evol: 0,
    credit_differed_duration: 0,
    is_differed_total: false,
    shares_number: 1,
    buying_year: 2024,
    fiscal_detailed_view: false,

    favorite_list: EMPTY_FAVORITE_LIST,
    loading: false,

    status: '',
    visite_link: '',
    hide: false,

    carac_filled: false,
    lot_copro: 0,
    has_copro: false,
    floor: 0,
    floor_building: 0,
    year_building: 0,
    orientation: '',

    bedrooms: 0,
    bathrooms: 0,
    shower_rooms: 0,
    restrooms: 0,
    parking: 0,
    cellar: false,
    pool: false,
    outside: false,

    // Diag
    energy_rate: '',
    energy_rate_value: 0,
    ges: '',
    ges_value: 0,
    ref_ademe: '',

    // Autre
    elevator: false,
    urgent: false,
    rent: false,
    work: false,
    renov: false,
    disabled_access: false,
    guardian: false,
    intercom: false,
    closed_view: false,
    digital_code: false,
    owner_type: '',
    heating: '',

    // Displayed calc data
    isSquareValid: false,
    smallLink: 0,
    providerLib: '',
    fullPriceLib: '',
    quartierLib: '',
};

export const SEARCH_PARAMS: SearchParams = {
    search: '',
    sort: '',
    sort_order: '',
    // Liste vide = pas de filtre côté API (type, catégorie, ancien/neuf) : rien de pré-coché à la réinitialisation
    estate_type: [],
    category: [],
    price: [],
    rooms: [0, 1, 2, 3, 4, 5],
    surface: [],
    surface_land: [],
    squarePrice: [],
    squarePriceDiff: [],
    dpe: [0, 1, 2, 3, 4, 5, 6, 7],
    month: [],
    rendement: [],
    cashflow: [],
    search_title: false,
    last: 0,
    search_city_params_id: 0,
    cities: [],
    owner_type: ['pro', 'private'],
    estate_sale: [],
    region: [],
    departement: [],
    work: ['nc', 'work', 'renov'],
    floor: ['nc', 'rdc', '1', '2plus', '_Last'],
    assets: [],
    rent: [0, 1],
    amount_copro: [],
    nb_lots: [],
    maison_divisible: false,
    opened: false,
    exclude_hidden: false,
    other: [],
    price_change_percent: [],
    price_change_euro: [],
};

export const SEARCH_CITY_PARAMS: CityParams = {
    region: [],
    departement: [],
    evol_demo: [],
    pop: [],
    tc: [],
    te: [],
    tv: [],
    mv: [],
    tl: [],
    squareRent: [],
    tensiometre: [],
    squarePriceCity: [],
    efficiencyCity: [],
    priceEvolCity_1: [],
    priceEvolCity_3: [],
    priceEvolCity_5: [],
    priceEvolCity_10: [],
    cities_include: [],
    cities_exclude: [],
    coeur_de_ville: false,
    denormandie: false,
    sort: 'name',
    sort_order: 'asc',
};
